import { Formik, FormikHelpers } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import LeadNoteForm, { LeadNoteFields } from './LeadNoteForm';
import { LeadNote as LeadNoteType } from '../../../../types';

interface LeadNoteNewProps {
    id: number;
    data: LeadNoteType;
    closeForm: () => void;
    updateHandler: (values: LeadNoteFields, actions: FormikHelpers<LeadNoteType>) => Promise<void>;
    deleteHandler: (id: number) => Promise<void>;
}

@inject('store')
@observer
class LeadNoteEdit extends React.Component<LeadNoteNewProps> {
    public initialValues = () => {
        return {
            ...this.props.data
        };
    };

    public render() {
        const colProps = {
            xs: 12
        };

        return (
            <Row className="block-indent__padding">
                <Col {...colProps}>
                    <Formik
                        enableReinitialize
                        initialValues={this.initialValues()}
                        onSubmit={this.handleSubmit}
                    >{LeadNoteForm({
                        controls: this.controls()
                    })}</Formik>
                </Col>
            </Row>
        );
    }

    public controls = () => {
        return (
            <>
                <Button className="right-indent" bsStyle="primary" type="submit">
                    Save
                </Button>
                <Button className="right-indent" bsStyle="default" type="reset" onClick={this.props.closeForm}>
                    Cancel
                </Button>
                <Button bsStyle="danger" type="reset" onClick={this.handleDelete}>
                    Delete
                </Button>
            </>
        );
    };

    public handleSubmit = (values: LeadNoteFields, actions: FormikHelpers<LeadNoteType>) => {
        return this.props.updateHandler(values, actions);
    };

    public handleDelete = () => {
        return this.props.deleteHandler(this.props.id);
    };
}

export default LeadNoteEdit;
